module.exports = __webpack_public_path__ + "img/14.ed73afb5.jpg";